/**
 * localStorage 유틸리티
 *
 * localSlice.ts에서 추출. 안전한 localStorage 읽기 헬퍼.
 */

export function loadBoolean(key: string, fallback: boolean): boolean {
  try {
    const v = localStorage.getItem(key);
    if (v === null) return fallback;
    return v === 'true';
  } catch { return fallback; }
}

export function loadNumber(key: string, fallback: number, min: number, max: number): number {
  try {
    const v = localStorage.getItem(key);
    if (v === null) return fallback;
    const n = Number(v);
    if (isNaN(n)) return fallback;
    return Math.max(min, Math.min(max, n));
  } catch { return fallback; }
}
